import {
  type PageInfo,
  type Sort,
  type TableDataSource,
  type TablePage,
} from './table-data-source';
import { BehaviorSubject, type Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { inject } from '@angular/core';
import { TableStateSelectors } from '../state/table-state.selectors';

export abstract class AbstractTableDataSource<T> implements TableDataSource<T> {
  protected store = inject(Store);

  get isLoading$(): Observable<boolean> {
    return new BehaviorSubject(false).asObservable();
  }

  abstract getData$(tableId: string): Observable<TablePage<T>>;

  protected getPagination$(tableId: string): Observable<PageInfo> {
    return this.store.select(TableStateSelectors.getPagination(tableId));
  }

  protected getSort$(tableId: string): Observable<Sort<T> | undefined> {
    return this.store.select(TableStateSelectors.getSort<T>(tableId));
  }
}
